var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "iframe-settings-modal",
      attrs: {
        visible: _vm.visible,
        title: "Iframe Ayarları - " + _vm.widget.title,
        width: "600px",
        footer: null,
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form, layout: "vertical" } },
        [
          _c(
            "a-form-item",
            { attrs: { label: "URL" } },
            [
              _c("a-input", {
                attrs: { placeholder: "https://example.com" },
                on: { change: _vm.validateUrl },
                model: {
                  value: _vm.previewSettings.url,
                  callback: function ($$v) {
                    _vm.$set(_vm.previewSettings, "url", $$v)
                  },
                  expression: "previewSettings.url",
                },
              }),
              _vm._v(" "),
              _vm.urlError
                ? _c("div", { staticClass: "error-message" }, [
                    _vm._v(_vm._s(_vm.urlError)),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("table.heightPx") } },
            [
              _c("a-input-number", {
                staticStyle: { width: "100%" },
                attrs: { min: 100, max: 2000 },
                model: {
                  value: _vm.previewSettings.height,
                  callback: function ($$v) {
                    _vm.$set(_vm.previewSettings, "height", $$v)
                  },
                  expression: "previewSettings.height",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-form-item", { attrs: { label: _vm.$t("table.autoRefresh") } }, [
            _c(
              "div",
              { staticClass: "refresh-interval-settings" },
              [
                _c("a-switch", {
                  model: {
                    value: _vm.autoRefreshEnabled,
                    callback: function ($$v) {
                      _vm.autoRefreshEnabled = $$v
                    },
                    expression: "autoRefreshEnabled",
                  },
                }),
                _vm._v(" "),
                _vm.autoRefreshEnabled
                  ? _c("a-input-number", {
                      staticStyle: { width: "120px" },
                      attrs: { min: 1, max: 3600 },
                      model: {
                        value: _vm.previewSettings.refreshInterval,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings, "refreshInterval", $$v)
                        },
                        expression: "previewSettings.refreshInterval",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.autoRefreshEnabled
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("table.seconds")))])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-form-item", { attrs: { label: _vm.$t("table.preview") } }, [
            _c(
              "div",
              { staticClass: "preview-container", style: { height: "300px" } },
              [
                _vm.isValidUrl
                  ? _c("iframe", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: { src: _vm.previewSettings.url, frameborder: "0" },
                    })
                  : _c("div", { staticClass: "preview-placeholder" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("link_off"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("table.enterValidUrl"))),
                      ]),
                    ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("table.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.saving,
                    disabled: !_vm.isValidUrl,
                  },
                  on: { click: _vm.handleSave },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("table.save")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }